import { useEffect, useRef } from 'react'

import { TourDefinition } from '@ui/components/Tourtip/Tourtip'

export function useOnTourStart(handler: (def: TourDefinition) => void) {
  const handlerRef = useRef(handler)
  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    const onStart = (e: Event) => {
      if (e instanceof CustomEvent) {
        handlerRef.current(e.detail as TourDefinition)
      }
    }
    window.addEventListener('tour:start', onStart as EventListener)

    return () => window.removeEventListener('tour:start', onStart as EventListener)
  }, [])
}
